import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import { OrderingPolicyControl } from './OrderingPolicyControl';
import { OrderingPolicyIdControl } from './OrderingPolicyIdControl';

export function OrderingPolicyWrapper(): JSX.Element {
  const { control } = useFormContext();
  const { isEditPage } = useCorporateFormContext();

  const showOrderingPolicyIdInput = useWatch({
    control,
    name: 'orderingPolicyEnabled',
  }) as boolean;

  return (
    <div>
      <OrderingPolicyControl
        name="orderingPolicyEnabled"
        id="orderingPolicyEnabled"
        isDisabled={!isEditPage}
      />
      {showOrderingPolicyIdInput && (
        <OrderingPolicyIdControl name="orderPolicyId" id="orderPolicyId" />
      )}
    </div>
  );
}
